import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../font-drawer.module.scss';
import { Heading } from '@dotcom/crown-ui';

export const FontDrawerHeader = () => {
  const { t } = useTranslation();
  return (
    <>
      <Heading as="h4" className={styles['headline']}>
        {t('fontDrawer.headline')}
      </Heading>
    </>
  );
};
